import { JsonUtils } from '../../utils/json.util'
import { UserType } from '../../utils/user.type'

/**
 * @class
 * @category Models
 * @subcategory auth
 * @property {string} [sub]
 * @property {string} [sub_type]
 * @property {string} [iss]
 * @property {number} [exp]
 * @property {number} [iat]
 * @property {string} [scope]
 * @property {boolean} [reset_password]
 * @property {string} [email]
 */
export class AccessToken {
    private _sub: string | undefined
    private _sub_type: UserType | undefined
    private _iss: string | undefined
    private _exp: number | undefined
    private _iat: number | undefined
    private _scope: string | undefined
    private _email?: string | undefined
    private _tfa?: boolean | undefined
    private _protected?: boolean | undefined

    get sub(): string | undefined {
        return this._sub
    }

    set sub(value: string | undefined) {
        this._sub = value
    }

    get sub_type(): UserType | undefined {
        return this._sub_type
    }

    set sub_type(value: UserType | undefined) {
        this._sub_type = value
    }

    get iss(): string | undefined {
        return this._iss
    }

    set iss(value: string | undefined) {
        this._iss = value
    }

    get exp(): number | undefined {
        return this._exp
    }

    set exp(value: number | undefined) {
        this._exp = value
    }

    get iat(): number | undefined {
        return this._iat
    }

    set iat(value: number | undefined) {
        this._iat = value
    }

    get scope(): string | undefined {
        return this._scope
    }

    set scope(value: string | undefined) {
        this._scope = value
    }

    get email(): string | undefined {
        return this._email
    }

    set email(value: string | undefined) {
        this._email = value
    }

    get tfa(): boolean | undefined {
        return this._tfa
    }

    set tfa(value: boolean | undefined) {
        this._tfa = value
    }

    get protected(): boolean | undefined {
        return this._protected
    }

    set protected(value: boolean | undefined) {
        this._protected = value
    }

    public fromJSON(json: any): AccessToken {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.sub !== undefined) {
            this.sub = json.sub
        }

        if (json.sub_type !== undefined) {
            this.sub_type = json.sub_type
        }

        if (json.iss !== undefined) {
            this.iss = json.iss
        }

        if (json.exp !== undefined) {
            this.exp = json.exp
        }

        if (json.iat !== undefined) {
            this.iat = json.iat
        }

        if (json.scope !== undefined) {
            this.scope = json.scope
        }

        if (json.email !== undefined) {
            this.email = json.email
        }

        if (json.tfa !== undefined) {
            this.tfa = json.tfa
        }

        if (json.protected !== undefined) {
            this.protected = json.protected
        }


        return this
    }

    public toJSON(): any {
        return {
            sub: this.sub ? this.sub : undefined,
            sub_type: this.sub_type ? this.sub_type : undefined,
            iss: this.iss ? this.iss : undefined,
            exp: this.exp ? this.exp : undefined,
            iat: this.iat ? this.iat : undefined,
            scope: this.scope ? this.scope : undefined,
            email: this.email ? this.email : undefined,
            tfa: this.tfa ? this.tfa : undefined,
            protected: this.protected ? this.protected : undefined,
        }
    }
}

export const RESET_TOKEN_ERROR = {
    code: 401,
    message: 'Invalid password reset token!',
    description: 'Token probably expired or already used. You can only use the reset token once while it is within its validity period.'
}
